import { logError } from '@bikemap/js/utility'

/** @type {import("../../utility/serializers").SerializerType} */
export const lngLatType = {

    serialize: raw => {
        if (!raw) return null
        if (Array.isArray(raw) && raw.length === 2) {
            return raw.join(',')
        }
        throw Error('Expected LngLatLike array. Got ' + (typeof raw) + ' instead.')
    },

    deserialize: serialized => {
        if (!serialized) return null
        try {
            return ('' + serialized).split(',')
        } catch (error) {
            // Just don't use this param
            logError(error.message)
            return null
        }
    },

}
